import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './routes/routes'
import App from './App.vue'
import store from './vuex/store'
import axios from 'axios'
import Cookies from 'js-cookie'

// LightBootstrap plugin and icons

import 'bootstrap-icons/font/bootstrap-icons.min.css'
import LightBootstrap from './light-bootstrap-main'
// import vue-awesome/icons
import 'vue-awesome/icons/home'
import 'vue-awesome/icons/users'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/user-graduate'
import 'vue-awesome/icons/user-tie'
import 'vue-awesome/icons/credit-card'
import 'vue-awesome/icons/file-alt'
import 'vue-awesome/icons/bell'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/money-bill'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/minus-square'
import 'vue-awesome/icons/check-square'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/hand-pointer'
import 'vue-awesome/icons/thumbs-down'
import 'vue-awesome/icons/thumbs-up'
import 'vue-awesome/icons/clipboard-list'
import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/angle-left'
import 'vue-awesome/icons/angle-right'
import 'vue-awesome/icons/school'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/paper-plane'
import 'vue-awesome/icons/sync'
import 'vue-awesome/icons/key'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/play-circle'
import 'vue-awesome/icons/paperclip'
import 'vue-awesome/icons/photo-video'
import 'vue-awesome/icons/newspaper'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/sign-in-alt'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/comments'
import 'vue-awesome/icons/file-pdf'
import 'vue-awesome/icons/microphone'
/* Register component with one of 2 methods */

import Icon from 'vue-awesome/components/Icon'

// import v-toaster
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'

// import format-price directive
import FormatPrice from './directives/format-price' // Adjust path as necessary
import Tooltip from '@/components/Tooltip'
Vue.component('Tooltip', Tooltip)
Vue.directive('format-price', FormatPrice)

// plugin setup
Vue.use(Toaster, { timeout: 5000 })
Vue.component('v-icon', Icon)
Vue.use(VueRouter)
Vue.use(LightBootstrap)

axios.interceptors.request.use(
  function (config) {
    config.headers = {
      Authorization: 'Bearer ' + Cookies.get('access_token'),
      tokentap: 'Sb7qmGAxCrqdZz370F5cGSNrcQNidjQ2',
      Accept: 'application/json'
    }
    config.onUploadProgress = (progressEvent) => {
      /* store.dispatch(
        "update_upload_percentage",
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      ); */
    }

    return config
  },
  (error) => Promise.reject(error)
)

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
  router,
  store: store,
  components: { App }
})
